import { gqlTalentUnionEnum as TALENT_UNION } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';
import { UnionStatusIndicatorEnum } from '../types';
import { TALENT_UNION_NON_MEMBER } from '../config';

export const useUnionStatusGroup = () => {
  const { t } = useTranslation();

  const intlRadioOptions = {
    [UnionStatusIndicatorEnum.noPreference]: t('common:label.noPreference'),
    [UnionStatusIndicatorEnum.specifyStatus]: t('common:label.specifyStatus'),
    [UnionStatusIndicatorEnum.member]: t('common:label.member'),
    [UnionStatusIndicatorEnum.nonMember]: t('common:label.nonMember'),
    [TALENT_UNION.ELIGIBLE]: t('common:label.eligible'),
    [TALENT_UNION.FICORE]: t('common:label.fiCore'),
  };

  return [
    {
      name: TALENT_UNION.SAG_AFTRA,
      label: 'SAG-AFTRA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        {
          value: UnionStatusIndicatorEnum.specifyStatus,
          label: intlRadioOptions[UnionStatusIndicatorEnum.specifyStatus],
        },
      ],
      checkboxGroup: [
        { value: TALENT_UNION.MEMBER, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: TALENT_UNION.ELIGIBLE, label: intlRadioOptions[TALENT_UNION.ELIGIBLE] },
        { value: TALENT_UNION.FICORE, label: intlRadioOptions[TALENT_UNION.FICORE] },
        { value: TALENT_UNION_NON_MEMBER, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.ACTRA,
      label: 'ACTRA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.AEA,
      label: 'AEA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.CAEA,
      label: 'CAEA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.EQUITY,
      label: 'Equity',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.MEAA,
      label: 'MEAA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.UBCP_ACTRA,
      label: 'UBCP / ACTRA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
    {
      name: TALENT_UNION.UDA,
      label: 'UDA',
      radioGroup: [
        {
          value: UnionStatusIndicatorEnum.noPreference,
          label: intlRadioOptions[UnionStatusIndicatorEnum.noPreference],
        },
        { value: UnionStatusIndicatorEnum.member, label: intlRadioOptions[UnionStatusIndicatorEnum.member] },
        { value: UnionStatusIndicatorEnum.nonMember, label: intlRadioOptions[UnionStatusIndicatorEnum.nonMember] },
      ],
    },
  ];
};
